module.exports = __webpack_public_path__ + "img/Group 82@2x.7b31e0ec.png";